<template>
  <b-form class="login-form" @submit.prevent="onSignin">
    <social-login :callback="callback" />

    <label class="divider">Or sign in with your email</label>

    <error-message
      v-if="!form.$getError('username') && !form.$getError('password')"
      class="text-center mb-3"
      sign=""
      :error="form.$errorMessage"
    ></error-message>

    <b-form-group class="col-12 px-0">
      <custom-input
        :value="form.username"
        type="email"
        placeholder="Email address"
        autofocus
        required
        :disabled="form.$busy"
        :is-invalid="form.$getError('username')"
        @change="usernameValue"
      ></custom-input>
      <error-message :error="form.$getError('username')"></error-message>
    </b-form-group>

    <b-form-group class="col-12 px-0">
      <custom-input
        ref="passwordInput"
        v-model="form.password"
        :type="this.showPassword ? 'text' : 'password'"
        placeholder="Password"
        required
        :disabled="form.$busy"
        :is-invalid="form.$getError('password')"
      >
        <template slot="icon">
          <b-icon
            class="show"
            :icon="this.showPassword ? 'eye-slash' : 'eye'"
            aria-hidden="true"
            @click="
              toggleShowPassword()
              focusPasswordField()
            "
          ></b-icon>
        </template>
      </custom-input>
      <error-message :error="form.$getError('password')"></error-message>
    </b-form-group>

    <div class="forgot-password text-right">
      <b-link class="form-link" @click="$refs.forgot.show()"
        >Forgot password?</b-link
      >
      <forgot-password-form ref="forgot"></forgot-password-form>
    </div>

    <b-button
      type="submit"
      class="submit-btn"
      variant="primary"
      block
      :disabled="form.$busy"
    >
      <b-spinner v-if="form.$busy" small></b-spinner>
      Sign in
    </b-button>
  </b-form>
</template>
<script>
/**
 * ==================================================================================
 * Login form
 * ==================================================================================
 **/

import { mapActions, mapGetters } from 'vuex'
import Form from '@/utils/form.js'
import CustomInput from '@/components/inputs/CustomInput.vue'
import ErrorMessage from '@/components/inputs/ErrorMessage.vue'
import SocialLogin from '@/components/SocialLogin.vue'
import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm.vue'
import IsEmail from 'isemail'

export default {
  components: {
    CustomInput,
    ErrorMessage,
    SocialLogin,
    ForgotPasswordForm
  },
  props: {
    /**
     * Custom callback function on successful login
     * @type {Function}
     */
    callback: {
      type: Function
    }
  },
  data: function () {
    return {
      showForgot: false,
      form: new Form({
        username: 'ypollich@example.net',
        password: 'password'
      }),
      showPassword: false
    }
  },

  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    ...mapGetters({
      getNeededVerification: 'auth/getNeededVerification'
    }),
    async onSignin() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await this.login(this.form.$data())
        .then(() => {
          /**
           * Run custom callback if it exists, if not redirect user
           * to onboarding page if they're missing a verification item
           */
          if (this.callback) {
            this.callback()
          } else {
            let route = this.getNeededVerification()
            if (route) {
              this.$router.push(route)
            } else {
              route = this.$route.query.redirect
                ? { path: this.$route.query.redirect }
                : { name: 'home' }

              this.$router.push(route)
            }
          }
        })
        .catch((error) => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
        })
    },

    async onGoogleLogin(data) {},

    toggleShowPassword() {
      this.showPassword = !this.showPassword
    },

    focusPasswordField() {
      this.$refs['passwordInput'].focus()
    },

    usernameValue(val) {
      this.form.username = val
      if (val !== '' && !IsEmail.validate(val)) {
        this.form.$setError('username', 'Must be a valid email address')
      } else {
        this.form.$clearError('username')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.login-form {
  width: 100%;
  max-width: 410px;
  margin: 40px auto;

  .divider {
    margin: 35px auto;
  }

  .social-login {
    width: 100%;
  }

  .forgot-password {
    font-size: 0.95rem;
    font-weight: 600;
    margin-bottom: 50px;
  }

  .submit-btn {
    margin-top: 50px;

    p {
      margin-bottom: 0;
    }
  }

  .terms-conditions {
    font-size: 0.95rem;
    width: 80%;
    margin: 40px auto 0 auto;

    a {
      text-decoration: underline;
    }
  }

  ::-ms-reveal {
    display: none;
  }
}
</style>
